interface EmployeeInfoSectionProps {
	employeeData: {
		name: string;
		employeeNumber: string;
		jobTitle: string;
		workStation: string;
		teamStructure: string;
	};
}

const EmployeeInfoSection: React.FC<EmployeeInfoSectionProps> = ({
	employeeData,
}) => {
	return (
		<div className="flex flex-col gap-4">
			<h3 className="text-lg font-semibold text-primary">
				Informações do colaborador
			</h3>
			<div className="grid grid-cols-5 gap-4">
				<div>
					<div className="mb-1 text-[12px] text-[#4A4A4A]">Nome</div>
					<input
						type="text"
						value={employeeData.name}
						readOnly
						className="h-8 w-full rounded-[4px] border border-gray-400 bg-gray-100 pl-2 text-xs text-gray-600"
					/>
				</div>
				<div>
					<div className="mb-1 text-[12px] text-[#4A4A4A]">Chapa</div>
					<input
						type="text"
						value={employeeData.employeeNumber}
						readOnly
						className="h-8 w-full rounded-[4px] border border-gray-400 bg-gray-100 pl-2 text-xs text-gray-600"
					/>
				</div>
				<div>
					<div className="mb-1 text-[12px] text-[#4A4A4A]">Cargo</div>
					<input
						type="text"
						value={employeeData.jobTitle}
						readOnly
						className="h-8 w-full rounded-[4px] border border-gray-400 bg-gray-100 pl-2 text-xs text-gray-600"
					/>
				</div>
				<div>
					<div className="mb-1 text-[12px] text-[#4A4A4A]">
						Local de Trabalho
					</div>
					<input
						type="text"
						value={employeeData.workStation}
						readOnly
						className="h-8 w-full rounded-[4px] border border-gray-400 bg-gray-100 pl-2 text-xs text-gray-600"
					/>
				</div>
				<div>
					<div className="mb-1 text-[12px] text-[#4A4A4A]">
						Estrutura de Turma
					</div>
					<input
						type="text"
						value={employeeData.teamStructure}
						readOnly
						className="h-8 w-full rounded-[4px] border border-gray-400 bg-gray-100 pl-2 text-xs text-gray-600"
					/>
				</div>
			</div>
		</div>
	);
};

export default EmployeeInfoSection;
